import React from 'react';
import { NavLink } from 'react-router-dom';

export const Navigation = () => {
  


  return (
    <div>

      <nav>
        <div className='nav-wrapper'>
          <a href="#!" data-target="mobile-demo" className="sidenav-trigger"><i className="material-icons">menu</i></a>
          <div className='side-nav hide-on-med-and-down'>

            <div className='nav-logo'>
              <img src='img/Clash-Royale-Logo-PNG-Background.png' alt='img' />
              <h1>Clash Royale API</h1>
            </div>

            <NavLink activeclass="active" to="/" className='bloc-link'>
              <i className="fas fa-home"></i>
              <span className='nav-links'>Accueil</span>
            </NavLink>
            <NavLink activeclass="active" to="/deck" className='bloc-link'>
              <i className="fas fa-book-open"></i>
              <span className='nav-links'>Deck</span>
            </NavLink>
            <NavLink activeclass="active" to="/coffre" className='bloc-link'>
              <i className="fas fa-suitcase"></i>
              <span className='nav-links'>Coffre</span>
            </NavLink>
            <NavLink activeclass="active" to="/stats" className='bloc-link'>
              <i className="fas fa-info"></i>
              <span className='nav-links'>Stats</span>
            </NavLink>
          </div>
        </div>
      </nav>


      <ul className="sidenav sidenav-close" id="mobile-demo">
        <NavLink activeclass="active" to="/" className='bloc-link'>
          <i className="fas fa-home"></i>
          <span className='nav-links'>Accueil</span>
        </NavLink>
        <NavLink activeclass="active" to="/deck" className='bloc-link'>
          <i className="fas fa-book-open"></i>
          <span className='nav-links'>Deck</span>
        </NavLink>
        <NavLink activeclass="active" to="/coffre" className='bloc-link'>
          <i className="fas fa-suitcase"></i>
          <span className='nav-links'>Coffre</span>
        </NavLink>
        <NavLink activeclass="active" to="/stats" className='bloc-link'>
          <i className="fas fa-info"></i>
          <span className='nav-links'>Stats</span>
        </NavLink>
      </ul>


    </div>);
};
